import {useFormikContext} from 'formik'
import React, {Fragment, useEffect} from 'react'

const FormikStep = ({ children, saveFields, datakey }) => {
  const {setFieldValue, setFieldTouched} = useFormikContext()
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem(datakey))
    if (data && saveFields) {
      console.info('Starting to load values from localStorage...')
      Object.keys(data).forEach(field => {
        console.log(field, data[field])
        setFieldValue(field, data[field])
        setFieldTouched(field, false, false)
      })
      console.info('')
    }
  }, [saveFields, setFieldValue, setFieldTouched, datakey])
  return <Fragment>{children}</Fragment>
}

FormikStep.defaultProps = {
  showControls: true,
  saveFields: true,
  submitText: 'Enviar'
}

export default FormikStep
